// src/constants/tokenLogos.ts
export const TOKEN_LOGOS: Record<string, string> = {
  // Solana tokens
  SOL: '/tokens/sol.png',
  USDT: '/tokens/usdt.png',
  USDC: '/tokens/usdc.png',
  FIXERCOIN: '/tokens/fixercoin.png',
  PINGX: '/tokens/pingx.png',
  LOCKER: '/tokens/locker.png',
  FXM: '/tokens/fxm.png',
  JUP: '/tokens/jup.png',
  BONK: '/tokens/bonk.png',
  PYTH: '/tokens/pyth.png',
  ORCA: '/tokens/orca.png',
  RAY: '/tokens/ray.png',
  JTO: '/tokens/jto.png',
  MEW: '/tokens/mew.png',
  WIF: '/tokens/wif.png',
  POPCAT: '/tokens/popcat.png',
  
  // EVM tokens
  BTC: '/tokens/btc.png',
  ETH: '/tokens/eth.png',
  BNB: '/tokens/bnb.png',
  MATIC: '/tokens/matic.png',
  UNI: '/tokens/uni.png',
  LINK: '/tokens/link.png',
  CAKE: '/tokens/cake.png',
  DAI: '/tokens/dai.png',
  XRP: '/tokens/xrp.png',
  SHIB: '/tokens/shib.png',
};

export const getTokenLogo = (symbol: string): string => {
  return TOKEN_LOGOS[symbol] || '/tokens/default.png';
};
